import React, { Fragment, useRef, useState } from 'react';
import { round } from 'lodash';
import { styled, ButtonBase, ClickAwayListener } from '@mui/material';

import { WorkloadAnalyticsPieChart } from 'components/molecules/PieChart';
import { Divider, Stack, Text } from 'shell/components';
import theme from 'shell/themes';
import { getUserPreferredFullName } from 'utils/helper';

const WorkloadAnalytics = ({ hideChart = false, students, stats, ...rest }) => {
    const chartRef = useRef(null);
    const [selected, setSelected] = useState('');

    const studentTotalPointsSum = Object.values(stats)?.reduce((acc, cur) => {
        return acc + cur.totalPoints;
    }, 0);

    Object.keys(stats || {}).forEach((ownerAccountId) => {
        const student = students.find(({ owner_account_id }) => owner_account_id === ownerAccountId);
        stats[ownerAccountId] = {
            ...stats?.[ownerAccountId],
            contributionPercentage: studentTotalPointsSum
                ? (stats?.[student ? student.owner_account_id : 'unassigned'].totalPoints / studentTotalPointsSum) * 100
                : 0,
        };
    });

    students = [
        ...students,
        {
            owner_account_id: 'unassigned',
            first_name: 'Unassigned',
            last_name: '',
            profile_circle: {
                bg_color: theme.palette.ensightful.neutral[200],
                text_color: theme.palette.ensightful.neutral[900],
            },
        },
    ];

    return (
        <Stack sx={{ mt: 3 }} {...rest}>
            {!hideChart && (
                <>
                    <WorkloadAnalyticsPieChart
                        ref={chartRef}
                        selected={selected}
                        students={students}
                        stats={stats}
                        onClick={setSelected}
                    />
                    <Text align={'center'} color={'light'} variant={'p3'}>
                        Total Workload assigned to each member.
                    </Text>
                </>
            )}
            <ClickAwayListener
                onClickAway={(e) => {
                    if (hideChart) return setSelected('');
                    if (!chartRef.current.contains(e.target)) setSelected('');
                }}
            >
                <Stack sx={{ mt: 4 }} divider={<Divider />} spacing={2}>
                    {students?.map((student) => (
                        <Fragment key={student.owner_account_id}>
                            <CustomButtonBase onClick={() => setSelected(student.owner_account_id)}>
                                <Stack sx={{ width: '100%' }} spacing={2}>
                                    <Stack direction={'row'} justifyContent={'space-between'}>
                                        <Text noWrap variant={'p2'}>
                                            {getUserPreferredFullName(student)}
                                        </Text>
                                        <Text variant={'p2'}>
                                            {!stats[student.owner_account_id].contributionPercentage
                                                ? 0
                                                : round(stats[student.owner_account_id].contributionPercentage)}
                                            %
                                        </Text>
                                    </Stack>
                                    {student.owner_account_id === selected ? (
                                        <Stack alignItems={'flex-start'}>
                                            <Text color={'light'} variant={'p3'}>
                                                Number of Points — {stats[student.owner_account_id].totalPoints}
                                            </Text>
                                        </Stack>
                                    ) : null}
                                </Stack>
                            </CustomButtonBase>
                        </Fragment>
                    ))}
                </Stack>
            </ClickAwayListener>
        </Stack>
    );
};

const CustomButtonBase = styled(ButtonBase)(({ theme }) => {
    return {
        borderRadius: '6px',
        '&:focus-visible': {
            outline: `${theme.palette.ensightful.secondary[100]} solid 3px`,
        },
    };
});

export default WorkloadAnalytics;
